import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/audit");

export const Route = createFileRoute("/audit")({
  head: () => ({
    meta: [
      { title: "Application logs — LevelLoad" },
      { name: "description", content: "Browse application activity and feed logs in LevelLoad." },
      { property: "og:title", content: "Application logs — LevelLoad" },
      {
        property: "og:description",
        content: "Browse application activity and feed logs in LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
